module.exports = __webpack_public_path__ + "img/v3.24ca9990.png";